import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { IconName, ICONS_MAP, ICONS_NAME_MAP } from '@app/shared/components/icon/icons';
import { ICON_SIZE_MAP, IconSize } from '@app/shared/components/icon/icon-size';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIconComponent,
  ],
  viewProviders: [
    provideIcons(ICONS_MAP),
  ],
})
export class IconComponent {
  public readonly name = input.required<IconName>();
  public readonly size = input.required<IconSize>();

  @HostBinding('class.tw-inline-flex') public hostClass = true;

  protected readonly ICONS_NAME_MAP = ICONS_NAME_MAP;
  protected readonly ICON_SIZE_MAP = ICON_SIZE_MAP;
}
